export default __webpack_public_path__ + "static/media/nike_stimuli.b8c36c08.mp4";